import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import ExtensionPost from './pages/ExtensionPost';
import ExtensionList from './pages/ExtensionList';
import SiteList from './pages/SiteList';
import NavBar from './components/NavBar';
import './App.css';

function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <>
                <NavBar />
                <Dashboard />
              </>
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <>
                <NavBar />
                <Admin />
              </>
            </ProtectedRoute>
          } />
          <Route path="/extension-post" element={
            <ProtectedRoute>
              <>
                <NavBar />
                <ExtensionPost />
              </>
            </ProtectedRoute>
          } />
          <Route path="/extension-list" element={
            <ProtectedRoute>
              <>
                <NavBar />
                <ExtensionList />
              </>
            </ProtectedRoute>
          } />
          <Route path="/site-list" element={
            <ProtectedRoute>
              <>
                <NavBar />
                <SiteList />
              </>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
